<template>
  <v-autocomplete label="平台" item-text="name" item-value="code" clearable
                  :loading="loading" :items="markets" v-model="selectedMarket" :rules="rules" :multiple="multiple" @click:clear="clear">
    <template v-slot:selection="data">
      <v-avatar width="25" height="25">
        <v-img width="25" height="25" contain
               :alt="data.item.name" :src="'icon/flag/' + data.item.code.toLowerCase() + '.png'"/>
      </v-avatar>
      {{ data.item.name }}
    </template>
    <template v-slot:item="data">
      <v-list-item-avatar>
        <v-img :alt="data.item.name" :src="'icon/flag/' + data.item.code.toLowerCase() + '.png'"/>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ data.item.name }}</v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "MarketSelector",
  model: {
    prop: "data",
    event: "update"
  },
  props: {
    data: String,
    multiple: {
      type: Boolean,
      default: false
    },
    rules: Array
  },
  computed: {
    selectedMarket: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  },
  data() {
    return {
      loading: false,
      markets: []
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$axios.get("/stores/marketplace").then(
          response => {
            this.loading = false;
            this.markets = response.data;
          }
      );
    },
    clear() {
      this.selectedMarket = null;
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped>

</style>